var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('admin-box-item',{attrs:{"title":"선택한 상품종류 화면"}},[_c('scroll-table-wrapper',{attrs:{"enableDragScroll":true}},[_c('div',{staticClass:"img-container unselect"},_vm._l((_vm.previewUrls),function(url,idx){return _c('img',{key:`preview-${idx}`,staticClass:"preview",attrs:{"src":url}})}),0)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }